export default "__VITE_ASSET__ng5D64pJ__"